// src/core/platform/electronBridge.ts
// Electron 환경 브릿지 — 기존 window.electronAPI 위임

import type { PlatformBridge, PlatformFeature, SaveDialogOptions, SaveDialogResult } from "./platformBridge"

export class ElectronBridge implements PlatformBridge {
  readonly platform = "electron" as const

  /** Electron에서는 모든 기능 사용 가능 */
  isFeatureAvailable(_feature: PlatformFeature): boolean {
    return true
  }

  // ── 파일 관련 ──

  async showSaveDialog(options?: SaveDialogOptions): Promise<SaveDialogResult> {
    if (!window.electronAPI?.showSaveDialog) {
      return { canceled: true }
    }
    return window.electronAPI.showSaveDialog(options)
  }

  async writeFile(path: string, content: string) {
    if (!window.electronAPI?.writeFile) {
      return { success: false, error: "writeFile unavailable" }
    }
    return window.electronAPI.writeFile(path, content)
  }

  async writeBinaryFile(path: string, data: Uint8Array | ArrayBuffer) {
    if (!window.electronAPI?.writeBinaryFile) {
      return { success: false, error: "writeBinaryFile unavailable" }
    }
    return window.electronAPI.writeBinaryFile(path, data)
  }

  async openFileLocation(filePath: string) {
    if (!window.electronAPI?.openFileLocation) {
      return { success: false, error: "openFileLocation unavailable" }
    }
    return window.electronAPI.openFileLocation({ filePath })
  }

  // ── 앱 제어 ──

  async openExternalUrl(url: string) {
    if (window.electronAPI?.openSystemBrowserUrl) {
      await window.electronAPI.openSystemBrowserUrl(url)
    }
  }

  async restartApp() {
    if (window.electronAPI?.restartApp) {
      await window.electronAPI.restartApp()
    }
  }

  async exitApp() {
    if (window.electronAPI?.close) {
      await window.electronAPI.close()
    }
  }

  // ── 서버 검색 ──

  async scanNetwork() {
    if (!window.electronAPI?.scanNetwork) return []
    return window.electronAPI.scanNetwork()
  }

  async checkServer(ip: string, port: number) {
    if (!window.electronAPI?.checkServer) return false
    return window.electronAPI.checkServer(ip, port)
  }

  async getLocalIp() {
    return null
  }

  async saveProxyConfig(config: unknown) {
    if (window.electronAPI?.saveProxyConfig) {
      await window.electronAPI.saveProxyConfig(config)
    }
  }
}

